import React from 'react';

export const errorCircleOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.9001 12C3.9001 7.52647 7.52659 3.89998 12.0001 3.89998C16.4736 3.89998 20.1001 7.52647 20.1001 12C20.1001 16.4735 16.4736 20.1 12.0001 20.1C7.52659 20.1 3.9001 16.4735 3.9001 12ZM12.0001 2.09998C6.53248 2.09998 2.1001 6.53236 2.1001 12C2.1001 17.4676 6.53248 21.9 12.0001 21.9C17.4677 21.9 21.9001 17.4676 21.9001 12C21.9001 6.53236 17.4677 2.09998 12.0001 2.09998ZM12.9001 7.89998C12.9001 7.40292 12.4971 6.99998 12.0001 6.99998C11.503 6.99998 11.1001 7.40292 11.1001 7.89998V13.1C11.1001 13.5971 11.503 14 12.0001 14C12.4971 14 12.9001 13.5971 12.9001 13.1V7.89998ZM13.0001 16C13.0001 16.5523 12.5524 17 12.0001 17C11.4478 17 11.0001 16.5523 11.0001 16C11.0001 15.4477 11.4478 15 12.0001 15C12.5524 15 13.0001 15.4477 13.0001 16Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const errorCircleFilled = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 23.25C18.1675 23.25 23.25 18.1583 23.25 11.9941C23.25 5.84167 18.1557 0.75 12 0.75C5.83255 0.75 0.75 5.84167 0.75 11.9941C0.75 18.1583 5.84434 23.25 12 23.25ZM8.06545 17C7.60455 17 7.25 16.6336 7.25 16.1845C7.25 15.96 7.33273 15.7591 7.48636 15.6173L10.9609 12.1309L7.48636 8.64455C7.33273 8.50273 7.25 8.30182 7.25 8.07727C7.25 7.61636 7.60455 7.27364 8.06545 7.27364C8.29 7.27364 8.47909 7.35636 8.63273 7.51L12.1191 10.9845L15.6173 7.51C15.7827 7.33273 15.9718 7.25 16.1845 7.25C16.6336 7.25 17 7.61636 17 8.06545C17 8.29 16.9291 8.46727 16.7518 8.63273L13.2655 12.1309L16.7518 15.5936C16.9055 15.7591 16.9882 15.9482 16.9882 16.1845C16.9882 16.6336 16.6336 17 16.1727 17C15.9364 17 15.7355 16.9055 15.5818 16.7518L12.1191 13.2773L8.64455 16.7518C8.50273 16.9055 8.29 17 8.06545 17Z'
        fill='#023F80'
      />
    </svg>
  );
};
